import { FormFieldOptionDetails, FormFieldOptions } from "@tellescope/types-models";

/**
 * Resolves a field's selectable options to the richer `optionDetails` shape.
 *
 * Choice fields carry their options in one of two shapes: the legacy `choices` (plain strings) or
 * `optionDetails` (option plus an optional description). Both remain valid — fields authored before
 * `optionDetails` existed still only have `choices` — so anything rendering or validating choices must
 * accept either. `optionDetails` wins when both are present.
 *
 * @param options - The field's `options` object, if any.
 * @returns Option details for the field, or an empty array when it defines no choices.
 */
export const resolveFieldOptionDetails = (options?: FormFieldOptions): FormFieldOptionDetails[] => {
  if (options?.optionDetails?.length) return options.optionDetails;
  return options?.choices?.map((option) => ({ option })) ?? [];
};
